<template>
    <ModalBase
        name="enviar-abonos"
        title="Enviar abonos"
        @close="() => close()"
    >
        <div class="row">
            <div class="col-12 text-center">
                <h1 class="font-weight-bold">¿ENVIAR TODOS LOS ABONOS?</h1>
            </div>
            <div class="col-12 text-center">
                <Button type="button" name="button" @click="enviarAbonos" :disabled="loading">SI, ENVIAR</Button>
            </div>
        </div>
    </ModalBase>
</template>

<script setup>
    import { ref } from 'vue'
    import store from '@/store'
    import { useToast } from '@/composables/common/useToast'
    import { config } from '@/config'
    import ModalBase from '@/modules/admin/ui/ModalBase'

    const props = defineProps({
        searchParams: Object
    })

    const emit = defineEmits(['close'])
    const toast = useToast()

    const loading = ref(false)

    const close = () => {
        emit('close', 'enviar-abonos')
    }

    const enviarAbonos = () => {
        loading.value = true

        const params = {
            ...props.searchParams,
            filters: { ...props.searchParams.filters }
        }
        delete params.filters.per_page
        delete params.filters.page

        store.dispatch(config.getVuexAlias('back.abonados.enviar'), params)
            .then(res => {
                toast.success('Abonos enviados')
                close()
            })
            .finally(() => {
                loading.value = false
            })
    }
</script>
